import { getLocale } from '@libs/core';

import { afterpayConfig } from '../constants/afterpayConfig';

export const getAfterpayConfig = () => {
    const locale = getLocale();

    return afterpayConfig[locale];
};
